export default {"src":"/_next/static/media/powered-stripe-light.ed6758c0.svg","height":34,"width":150};